// eslint-disable-next-line import/prefer-default-export
export const MODULE_NAME = 'headTags';
